import { SearchTreeInternalNode, SearchTreeNode, isSearchTreeLeafNode } from '@/types';

/** Mutates the tree in place to remove all _leafNodeId and _internalNodeId properties */
export function walkTreeAndRemoveEphemeralIdsInPlace(tree: SearchTreeNode): void {
  walkNodeAndRemoveEphemeralIds(tree);
}

/** Returns a new tree with all _leafNodeId and _internalNodeId properties removed */
export function walkTreeAndRemoveEphemeralIds(
  tree: SearchTreeNode | undefined
): SearchTreeNode | undefined {
  if (!tree) {
    return undefined;
  }
  const newTree = structuredClone(tree);
  walkNodeAndRemoveEphemeralIds(newTree);
  return newTree;
}

function walkNodeAndRemoveEphemeralIds(node: SearchTreeNode): void {
  if (isSearchTreeLeafNode(node)) {
    delete node._leafNodeId;
  } else {
    const internalNode = node as SearchTreeInternalNode;
    delete internalNode._internalNodeId;
    for (const childNode of internalNode.nodes) {
      walkNodeAndRemoveEphemeralIds(childNode);
    }
  }
}

export function walkTreeAndFindNodeByEphemeralId(
  tree: SearchTreeNode,
  nodeId: string
): SearchTreeNode | undefined {
  return findNodeByEphemeralId(tree, nodeId);
}

function findNodeByEphemeralId(node: SearchTreeNode, nodeId: string): SearchTreeNode | undefined {
  if (isSearchTreeLeafNode(node)) {
    return node._leafNodeId === nodeId ? node : undefined;
  } else {
    if (node._internalNodeId === nodeId) return node;

    for (const subNode of node.nodes) {
      const match = findNodeByEphemeralId(subNode, nodeId);
      if (match) return match;
    }

    return undefined;
  }
}
